class AccessController {
  async canAppend (entry, identityProvider) {
    return true
  }
}

export default AccessController
